import "es6-shim";
import Vue from "vue";
import vueHeadful from "vue-headful";
import VueConfig from "vue-configuration";
import appSettings from "./settings";
import VueI18N from "vue-i18n";
import App from "./App";
import { sync } from "vuex-router-sync";
import router from "./router/index";
import RouterEvent from "./router/RouterEvent";
import moment from "moment";
import { store } from "./state/store";
import listener from "./state/listener";
import myIp from "quick-local-ip";
import nprogress from "nprogress";
import VueCarousel from "vue-carousel";
import * as VueGoogleMaps from "vue2-google-maps";
import BootstrapVue from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-material-design-icons/styles.css";
import "font-awesome/scss/font-awesome.scss";
import "./assets/style/main.scss";

import "vue-material-design-icons/styles.css";
import "font-awesome/scss/font-awesome.scss";
import Notifications from "vue-notification";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";

Vue.config.productionTip = false;
Vue.use(Croppa);
Vue.config.productionTip = false;
Vue.use(VueI18N);
Vue.use(VueConfig, { config: appSettings });
Vue.use(Notifications);
moment.locale("pl");
Vue.use(VueCarousel);
Vue.component("vue-headful", vueHeadful);
Vue.use(BootstrapVue);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC0c1qzC4dbHuFqPcOMvX2159mZXj6fukc",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

sync(store, router);

listener.init();

const AppUi = function(el) {
  console.log(appSettings);

  store.dispatch("createTicket", {
    ip: myIp.getLocalIP4(),
    domain: appSettings.application.domain,
    referer: document.referrer,
    browser: navigator.userAgent,
    AppId: "NEW IPH",
    language: "pl",
    currency: "PLN"
  });

  return {
    el,
    store,
    router,
    render: h => h(App)
  };
};

router.beforeEach((to, from, next) => {
  RouterEvent.beforeEach(to, from, store.state);
  next();
});

document.addEventListener("DOMContentLoaded", async () => {
  const element = document.getElementById("app");

  try {
    new Vue(AppUi(element));
  } catch (e) {
    console.log(e);
  }
});



// WEBPACK FOOTER //
// ./src/main.js